import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {EmailService} from '../../../Services/email.service';
import {BehaviorSubject} from 'rxjs';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import * as moment from 'moment';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {Email} from '../../../Models/Email';
import {FormControl} from '@angular/forms';
import {environment} from '../../../../../environments/environment';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {LanguageService} from '../../../../translation/Services/language.service';

@Component({
  selector: 'app-email-log',
  templateUrl: './email-log.component.html',
  styleUrls: ['./email-log.component.scss']
})
export class EmailLogComponent implements OnInit {

  public grid: Grid;
  public emailPreview;
  public iframeUrl: SafeResourceUrl;
  @ViewChild('previewModal', {static: false}) previewModal = null;
  @ViewChild('resendModal', {static: false}) resendModal = null;
  @ViewChild('emailsTooltip', {static: true}) emailsTooltip;
  public email: Email = new Email();
  public errorMessages = {
    'email': 'email is not valid',
  };
  public cc: string[] = [];
  public bcc: string[] = [];
  public ccInput: string = '';
  public bccInput: string = '';

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private emailService: EmailService,
    private sanitizer: DomSanitizer,
    private auth: AuthenticationService,
    private broadcastService: BroadcastService,
    private languageService: LanguageService
  ) {
  }

  ngOnInit() {
    const dateFormat = this.auth.getDateFormat();
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.emails.date',
          prop: 'date',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => moment(row).format(dateFormat + ' HH:mm'),
        },
        <TextColumn>{
          name: 'doctrine.emails.subject',
          prop: 'subject',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.emails.to',
          prop: 'receive',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.emails.cc',
          prop: 'cc',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          noTruncate: true,
          valueTemplate: this.emailsTooltip
        },
        <TextColumn>{
          name: 'doctrine.emails.bcc',
          prop: 'bcc',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          noTruncate: true,
          valueTemplate: this.emailsTooltip
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => {
                this.updateIframe(row.text);
                this.previewModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-repeat fa-lg',
              tooltip: 'admin.emails.manage.resend_email',
              onclick: row => {
                this.updateIframe(row.text);
                this.bcc = !row.bcc ? [] : row.bcc.map(email => {
                  if (!email) {
                    return null;
                  }
                  return {display: email, value: email};
                }).filter(function (e) {
                  return e;
                });
                this.cc = !row.cc ? [] : row.cc.map(email => {
                  if (!email) {
                    return null;
                  }
                  return {display: email, value: email};
                }).filter(function (e) {
                  return e;
                });
                this.email.id = row.id;
                this.email.to = row.receive;
                this.resendModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            }
          ]
        }
      ],
      service: this.emailService,
      rememberURL: this.router.url,
      method: 'getLog',
      defaultSort: 'topic',
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          name: 'language_id',
          type: 'ng-select',
          label: 'doctrine.attributes.language',
          hasDropdownListFilter: true,
          hasNormalSearch: true
        },
      ],
    };
  }

  public updateIframe(html) {
    const url = new Blob([html], {type: 'text/html'});
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(url));
  }

  resend() {
    setTimeout(() => {
      const email = <Email>Object.assign({}, this.email);
      email.bcc = [];
      for (const tag of this.bcc) {
        if (!email.bcc.includes(tag, 0)) {
          email.bcc.push(tag);
        }
      }
      email.cc = [];
      for (const tag of this.cc) {
        if (!email.cc.includes(tag, 0)) {
          email.cc.push(tag);
        }
      }
      delete email.to;
      delete email.id;
      this.emailService.logResend(this.email.id, {receive: this.email.to, ...email}).subscribe(resp => {
        this.resendModal.hide();
        this.broadcastService.broadcast('refreshGrid', 'getLog');
      });
    }, 500);
  }

  addEmail(event: any, type: 'cc' | 'bcc'): void {
    const input = type === 'cc' ? this.ccInput : this.bccInput;
    const value = input.replace(',', '').trim();
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (value && emailRegex.test(value)) {
      if (type === 'cc') {
        if (!this.cc.includes(value)) {
          this.cc.push(value);
        }
        this.ccInput = '';
      } else {
        if (!this.bcc.includes(value)) {
          this.bcc.push(value);
        }
        this.bccInput = '';
      }
    }
  }

  removeEmail(email: string, type: 'cc' | 'bcc'): void {
    if (type === 'cc') {
      this.cc = this.cc.filter(e => e !== email);
    } else {
      this.bcc = this.bcc.filter(e => e !== email);
    }
  }
}
